import React from 'react';
import { withGlobalProvider } from 'providers/globalProvider';
import { storeWrapper } from '@state/store';
import { GetStaticProps } from 'next';
import { MyBookingLoginPageLayout } from '@layout/MyBookingPageLayout/MyBookingLoginPageLayout';
import { initializeApp } from '@state/initializeApp';
import { MyBookingToken } from '@model/mmb';
import { Revalidate } from '@model/config/revalidate';
import { useSelector } from 'react-redux';
import { getBookingToken } from '@state/slices/mmb';
import { withMMBLogin } from '@components/hoc/with-auth/with-auth';

/* ***************** *
 *       Types       *
 * ***************** */
export interface MyBookingLoginPageProps {}

/* ************************ *
 *    MyBookingLoginPage    *
 * ************************ */
const MyBookingLoginPage = (props: MyBookingLoginPageProps) => {
  const bookingToken: MyBookingToken = useSelector(getBookingToken);

  if (bookingToken.loginToken) {
    return null;
  }

  return <MyBookingLoginPageLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps((store) => async () => ({
  ...(await initializeApp(store)),
  revalidate: Revalidate.HALF_HOUR
}));

export default withGlobalProvider(withMMBLogin(MyBookingLoginPage, true));
